var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPictoRematch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 11H0V1.375C0 1.01033 0.144866 0.660591 0.402728 0.402728C0.660591 0.144866 1.01033 0 1.375 0L9.625 0C9.98967 0 10.3394 0.144866 10.5973 0.402728C10.8551 0.660591 11 1.01033 11 1.375V11ZM0.916667 10.0833H10.0833V1.375C10.0833 1.25344 10.035 1.13686 9.94909 1.05091C9.86314 0.964955 9.74656 0.916667 9.625 0.916667H1.375C1.25344 0.916667 1.13686 0.964955 1.05091 1.05091C0.964955 1.13686 0.916667 1.25344 0.916667 1.375V10.0833ZM3.66667 8.12304V2.87696L8.25733 5.5L3.66667 8.12304ZM4.58333 4.45638V6.54363L6.40933 5.5L4.58333 4.45638Z",
    fill: "#051371"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoRematch);
export default __webpack_public_path__ + "static/media/pictoRematch.be726a7a43401eb0dc7601035455b620.svg";
export { ForwardRef as ReactComponent };